import { parse } from 'qs';
import trimStart from 'lodash/trimStart';
import intersection from 'lodash/intersection';

const AFF_LANDING_LENGTH = 4;
const AFF_TOKEN_START = 4;
const AFF_TOKEN_END = 14;
const PROMO_CODE_LENGTH = 16;

const tags = [
  'promo',
  'saff_id',
  'http_referer',
  'utm_source',
  'utm_campaign',
  'utm_medium',
  'utm_content',
  'utm_term',
  'clickid',
  'pid',
  'project',
  'm_click',
  'extra_param',
];

const buildPromoParams = (params, config) =>
  intersection(Object.keys(params), config).map((key) => ({ name: key, value: params[key] }));

const parsePromoValue = (promo) => {
  if (!promo || typeof promo !== 'string') {
    return {
      aff_landing: '',
      aff_token: '',
    };
  }

  return {
    aff_landing: promo.length >= AFF_LANDING_LENGTH ? promo.slice(0, AFF_LANDING_LENGTH) : '',
    aff_token: promo.length >= AFF_TOKEN_END ? promo.slice(AFF_TOKEN_START, AFF_TOKEN_END) : '',
  };
};

export default (queryString) => {
  if (!queryString) {
    return {};
  }

  const params = parse(trimStart(queryString, '?'));
  const promoParams = buildPromoParams(params, tags);
  const result = {};

  promoParams.forEach(({ name, value }) => {
    result[name] = value;
  });

  if (result.promo) {
    const fullPromo = result.promo;
    const { aff_landing, aff_token } = parsePromoValue(fullPromo);

    result.promo = fullPromo.length >= PROMO_CODE_LENGTH ? fullPromo.slice(-PROMO_CODE_LENGTH) : fullPromo;
    result.aff_landing = aff_landing;
    result.aff_token = aff_token;
  }

  return result;
};
